import React, { useState } from "react";
import Physician from "../../../Physician/Models/Physician";
import { AbccAssessment } from "../Models/CCAssessment";
import { Card, Col, Row } from "react-bootstrap";
import CCBlockSummaryMedicalLicenseCard from "./CCBlockSummaryMedicalLicenseCard";
import CCBlockSummaryActivitiesCard from "./CCBlockSummaryActivitiesCard";
import CCBlockSummaryAnnualFeesCard from "./CCBlockSummaryAnnualFeesCard";
import CCBlockSummaryAssessmentsCard from "./CCBlockSummaryAssessmentsCard";
import { getDateWithOffset } from "../../../Shared/Utility/GetDateWithOffset";
import { CertificationGeneration } from "../../../Physician/Models/Certificate";


interface IProps{
    physician: Physician;
    abccAssessments: AbccAssessment[];
}

export default function CCBlockSummaryContainer(props: IProps) {

    const showNotMeeting = getDateWithOffset(props.physician.currentCCEnrollment?.currentCCBlock?.endDate) < new Date() && 
                            (props.physician.currentCCEnrollment?.currentCCBlock?.extensionDate == null || getDateWithOffset(props.physician.currentCCEnrollment?.currentCCBlock?.extensionDate) < new Date());
    var headerSubtext = showNotMeeting == true ? "Certified - Not Meeting CC Requirements" : "Certified - Meeting CC Requirements";
    if (props.physician.certificates.every(_ => _.certificationGeneration == CertificationGeneration.Lifetime)) {
        headerSubtext = "";
    }

    if (props.abccAssessments == null || props.physician == null || props.physician.currentCCEnrollment == null) return <div />
        return (
            <Card className="mb-4" border="pp-secondary-grey" bg={showNotMeeting ? "pp-danger" : "pp-background"}>

                <Card.Body>
                    <Card.Title className="mb-0 font-weight-bolder text-center">                 
                        <span className="text-uppercase">
                            My Continuing Certification Enrollment
                        </span>
                        {headerSubtext.length > 1 && 
                        <span className="text-uppercase">
                            <br />
                            {headerSubtext}
                        </span>
                        }
                    </Card.Title>
                </Card.Body>
                <Row>
                    <Col>
                        <Row>
                            <Col className="pr-md-0">
                                <CCBlockSummaryMedicalLicenseCard physician={props.physician} showNotMeeting={showNotMeeting}/>
                            </Col>
                            <Col className="px-md-0">
                                <CCBlockSummaryActivitiesCard physician={props.physician} showNotMeeting={showNotMeeting}/>
                            </Col>
                            <Col className="px-md-0">
                                <CCBlockSummaryAnnualFeesCard physician={props.physician} showNotMeeting={showNotMeeting} />
                            </Col>
                            <Col className="pl-md-0">
                                <CCBlockSummaryAssessmentsCard physician={props.physician} abccAssessments={props.abccAssessments} showNotMeeting={showNotMeeting} />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <br />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="text-center pp-font-size-smallest">
                            For more detailed information and managing your requirements, navigate to the associated section of this dashboard.
                        </div>
                    </Col>
                </Row>
            </Card>
        );
}